import { create } from "zustand";
import { persist } from "zustand/middleware";

const applyTheme = (theme) => {
  const dark =
    theme === "dark" ||
    (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", dark);
};

export const useThemeStore = create(
  persist(
    (set, get) => ({
      theme: "system",
      density: "comfortable",

      setTheme: (theme) => {
        applyTheme(theme);
        set({ theme });
      },

      toggleTheme: () => {
        // Cycles light -> dark -> system so "follow my OS" stays reachable
        // without burying it in a settings page.
        const next = { light: "dark", dark: "system", system: "light" }[get().theme];
        applyTheme(next);
        set({ theme: next });
      },

      setDensity: (density) => set({ density }),

      syncSystemTheme: () => {
        if (get().theme === "system") applyTheme("system");
      },
    }),
    // The key and shape must match the inline script in index.html that runs
    // before React mounts, or the anti-flash guard reads nothing.
    { name: "hrms-theme", partialize: (s) => ({ theme: s.theme, density: s.density }) }
  )
);
